/**
 * Utility function for extracting search string
 *
 * https://SearchString.co.nz = SearchString
 * www.SearchString.com = SearchString
 * Searchstring.nz/morestuff = SearchString
 * Searchstring.nz?=morestuff = SearchString
 * māōrī.com = māōrī
 * www.search-string.com
 * [Jumpstarter only] www.search_string.com
 *
 * @return {string}
 */
export const extractSearchString = (searchString, isJumpstarter = false) => {
  if (searchString) {

    // extract domain
    let extractedSearchString = ''
    if (isJumpstarter) {
      // allow unsupported characters in the extracted string so that they can be replaced in next step.
      return searchString.replace(/.+\/\/|www\.|\..+/g, '');
    } else {
      extractedSearchString = searchString.match(/(?:[a-zA-Z0-9Ā-ū](?:[a-zA-Z0-9Ā-ū]{0,61}[a-zA-Z0-9Ā-ū])?\.)+[a-zA-Z0-9Ā-ū][a-z0-9-]{0,61}[a-zA-Z0-9Ā-ū]/g);
    }

    // get first match
    if (extractedSearchString && extractedSearchString.length > 0) {
      // remove domain extensions
      const filteredSearchString = extractedSearchString[0].replace(/.+\/\/|www.|\..+/g, '');

      return filteredSearchString;
    }
  }

  return searchString;
};

// macrons
// Ā U+0100 0192
// ā U+0101 0193
// Ē U+0112 0210
// ē U+0113 0211
// Ī U+012A 0234
// ī U+012B 0235
// Ō U+014C 0268
// ō U+014D 0269
// Ū U+016A 0298
// ū U+016B 0299

export default extractSearchString;
